import { ChangeDetectionStrategy, Component, OnChanges } from '@angular/core';

import { Question } from '@player/+survey/question/question-base';
import { SafeHtml } from '@shared/pipes/safe-html.pipe';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';
import { AsyncPipe } from '@angular/common';
import { BasicModule } from '@shared/modules/basic.module';

@Component({
  selector: 'input-info',
  templateUrl: './input-info.component.html',
  styleUrls: ['./input-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SafeHtml, SharedModuleForPlayer, AsyncPipe, BasicModule],
})
export class InputInfo extends Question<any> implements OnChanges {
  ngOnChanges() {
    if (this.isActive && !this.answer) {
      setTimeout(() => this.submitAnswer(true), Question.swiperDelay);
    }
  }

  submitAnswer(value: boolean) {
    if (!this.answer) {
      super.submitAnswer(value);
    }
  }
}
